import React, { useEffect, useRef } from 'react'
import { Switch, View } from 'react-native'
import { disabledSwitch, toqueColor, white } from '../../theme/colors'
import { useForm } from '../../hooks/useForm'

interface Props {
  isActive: boolean
  onPress: (value: boolean) => void
}

export const SwitchComponent = ({ onPress, isActive }: Props) => {
  const isFirstRender = useRef(true)
  const { values, onChangeValues } = useForm({
    isActive,
  })

  useEffect(() => {
    if (!isFirstRender.current) {
      onPress(values.isActive)
    }

    isFirstRender.current = false
  }, [values])

  return (
    <View
      style={[
        { borderWidth: 1, borderRadius: 20 },
        { borderColor: values.isActive ? toqueColor : disabledSwitch },
      ]}
    >
      <Switch
        trackColor={{ false: disabledSwitch, true: white }}
        thumbColor={values.isActive ? toqueColor : disabledSwitch}
        ios_backgroundColor={white}
        onValueChange={() => onChangeValues({ name: 'isActive', value: !values.isActive })}
        value={values.isActive}
      />
    </View>
  )
}
